<template>
    <div class="workordrAssign" style="margin-bottom:12px">
        <!--<div class="workordr_tip">-->
        <!--<i class="icon-icon_tip"></i>工单分配至相应承办单位-->
        <!--</div>-->
        <div class="workordr_content">
            <el-form label-width="130px"
                     :model="ruleForm"
                     label-position="left"
            > <div class="workordr_content_title">
                <div class="workordr_content_title_left">
                    <span></span>
                    <p>工单归档</p>
                </div>
            </div>
                <div class="workordr_main">
                    <el-form-item label="处理结果">
                        <el-input :autosize="{ minRows: 5}" v-model="ruleForm.czCzjgwb" maxlength="2000" show-word-limit type="textarea"/>
                    </el-form-item>
                </div>
                <el-form-item class="workordrAssign_btn">
                    <div class="workordrAssign_btn_cancle" @click="cancleClick">
                        取消
                    </div>
                    <div class="workordrAssign_btn_sure" @click="submitForm">
                        确认
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {reactive, getCurrentInstance} from 'vue';
    import {useStore} from 'vuex';
    import {ElMessageBox,ElLoading} from 'element-plus'

    export default {
        name: "Workorder_GDQS",
        props: ["gdId"],
        setup(props, context) {
            const store = useStore();
            const {proxy} = getCurrentInstance();
            const ruleForm = reactive({
                "czCzlx": 'GDGD',
                "gdId": props.gdId,
                czCzjgwb:""

            });
            const submitForm = () => {
                let loading;
                ElMessageBox.confirm('请确认是否继续', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    callback: (action) => {
                        if(action=="confirm"){
                            loading = ElLoading.service({
                                lock: true,
                                text: 'Loading',
                                background: 'rgba(0, 0, 0, 0.7)',
                            })
                            proxy.$axios.post("/jgfast/wgsj/gdcz", ruleForm).then((res) => {
                                context.emit("gdChildToParent");
                                store.state.addNewWorkorderSuccess=true;
                                loading.close()
                            }).catch(e=>{
                                loading.close();
                            });
                        }
                    },
                })
            };
            //取消事件
            const cancleClick=()=>{
                context.emit("workorderCancle");
                // ElMessageBox.confirm('请确认是否取消', '提示', {
                //     confirmButtonText: '确认',
                //     cancelButtonText: '取消',
                //     callback: (action) => {
                //         if(action=="confirm"){
                //             context.emit("workorderCancle");
                //         }
                //     },
                // })
            }
            return {
                ruleForm,
                submitForm,
                cancleClick
            }
        }
    }
</script>

<style scoped>

</style>
